// extracted by mini-css-extract-plugin
export default {"breadcrumb":"BreadcrumbLinks_breadcrumb__b7Nfe","breadcrumb-item":"BreadcrumbLinks_breadcrumb-item__-nEsb","active":"BreadcrumbLinks_active__Oug6g"};